import React from 'react'

import IFrame from 'components/IFrame'
import { images } from 'packages/simplesat-config'
import { Label, Segment, Image } from 'semantic-ui-react'

/**
 * @param {object} props
 * @param {string} props.htmlEmbedCode
 * @param {number} [props.embedPreviewIframeHeight]
 */
export const EmbedPreview = ({ htmlEmbedCode, embedPreviewIframeHeight }) => {
  return (
    <Segment.Group>
      <Segment
        compact
        style={{
          paddingTop: '.3em',
          paddingBottom: '.1em',
          backgroundColor: '#F8F8F8',
        }}
      >
        <Label basic empty circular className="white" />
        <Label basic empty circular className="white" />
        <Label basic empty circular className="white" />
      </Segment>
      <Segment>
        <Image src={images.emailSkeleton} alt="email skeleton" style={{ height: '8.75rem' }} />
        <IFrame className="mt-4" height={embedPreviewIframeHeight}>
          <div
            style={{ fontFamily: 'Lato, Helvetica, Arial, sans-serif' }}
            dangerouslySetInnerHTML={{
              __html: htmlEmbedCode,
            }}
          />
        </IFrame>
      </Segment>
    </Segment.Group>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/EmbedPreview/index.js